jQuery(($) => {
    $('.m-small-content-block-tabs').each(function () {
        var tabItem = $(this).find('.m-small-content-block-tabs__tab-item');

        tabItem.click(function(){
            var variation = $(this).data('variation');

            $('.m-small-content-block-tabs__tab-item').removeClass('m-small-content-block-tabs__tab-item--active');
            $(this).addClass('m-small-content-block-tabs__tab-item--active');

            $(".m-small-content-block-tabs__main").removeClass('m-small-content-block-tabs__main--active');
            $(".m-small-content-block-tabs__main[data-variation='" + variation + "']").addClass('m-small-content-block-tabs__main--active');
        })
    });
});